import { DotLabel } from "components/Dot";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import React from "react";
import StatesTablePanel from "./StatesTablePanel";
import { formatTimeZone, getTimeZoneFromIana } from "shared/utils/dateTimeUtils";
import { formatTime } from "utilities";
import moment from "moment";

interface CountryDetailSectionProps {
  viewModel: server.viewmodel.CountryDetailFrontModel
}

export const CountryDetailSection = (props: CountryDetailSectionProps) => {
  const { viewModel } = props;

  const tz = getTimeZoneFromIana(viewModel.ianaTimeZoneId, serverReference.culture.uiLocale);

  return <DetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    sections={[
      {
        type: "regular",
        key: "country",
        title: RESX.Address.Country,
        fields: [{
          key: "name",
          label: RESX.GeneralLabels.Name,
          render: () => <div>
            {Object.keys(viewModel.countryNameTranslations)
              .map(countryCode => (<div key={countryCode}>
                {countryCode} {viewModel.countryNameTranslations[countryCode]}
              </div>))}
          </div>
        },
        {
          key: "iso3166code",
          label: "ISO 3166 Code",
          render: () => <div>{viewModel.country.code}</div>
        }, {
          key: "region",
          label: RESX.Region.resxRegion,
          render: () => <div>{viewModel.region}</div>
        }, {
          key: "isInEu",
          label: RESX.VatNumber.InEU,
          render: () => <DotLabel dotColor={viewModel.country.isEuMember ? serverReference.constants.colors.green : serverReference.constants.colors.red} />
        }, {
          key: "callingCode",
          label: RESX.GeneralLabels.CallingCode,
          render: () => <div>{viewModel.callingCode}</div>
        }, {
          key: "timeZone",
          label: RESX.DateTime.Timezone,
          render: () => <div>
            <div>{tz.value}</div>
            <div>{formatTimeZone(tz)}</div>
          </div>
        }, {
          key: "localTime",
          label: RESX.DateTime.LocalTime,
          render: () => <div>{formatTime(moment.utc().tz(tz.value))}</div>
        }, {
          key: "numberAndDate",
          label: RESX.GeneralLabels.NumberAndDate,
          render: () => <div>{viewModel.cultureInfo}</div>
        }, {
          key: "countryId",
          label: "Country ID",
          render: () => <div>{viewModel.countryId}</div>
        }]
      }, {
        type: "custom",
        key: "states",
        render: () => <StatesTablePanel states={viewModel.states} countryName={viewModel.country.name} />,
      }

    ]}
  />
}

